// extracted by mini-css-extract-plugin
module.exports = {"floatingTypeaheadWrapper":"FloatingLinkInput_floatingTypeaheadWrapper__0WbIT","errorContainer":"FloatingLinkInput_errorContainer__DCjRs"};